import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
});

// Interceptor para agregar el token JWT a todas las peticiones
instance.interceptors.request.use(
  (config) => {
    const token = process.env.VUE_APP_JWT_TOKEN;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta (opcional)
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error("Token no válido o expirado");
    }
    return Promise.reject(error);
  }
);

export default instance;
